export default "/images/arrow-down-square.svg?8ee98e8423502b7ea9f01bb083f94687";